var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLobbyUsers = function SvgLobbyUsers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.714 19.429v-1.714a3.429 3.429 0 0 0-3.428-3.429H6.429A3.429 3.429 0 0 0 3 17.715v1.714M9.857 10.857a3.429 3.429 0 1 0 0-6.857 3.429 3.429 0 0 0 0 6.857Z",
    stroke: "#0377AD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 4a3.43 3.43 0 0 1 0 6.641M21 19.429v-1.713c0-2.573-1.286-3.43-2.571-3.43",
    stroke: "#0377AD",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
};
export default SvgLobbyUsers;